<template>
	<input class="v-input" :type="originType" :width="width" :height="height" :min="min" :max="max" :minlength="minLength" :maxlength="maxLength" :placeholder="placeholder" :autocomplete="autoComplete" v-model="model" ref="input"/>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    type: {
      default: null
    },
    width: {
      default: null
    },
    height: {
      default: null
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    minLength: {
      default: null
    },
    maxLength: {
      default: null
    },
    placeholder: {
      default: null
    },
    autoComplete: {
      default: "off"
    }
  },
  computed: {
    originType() {
      return { integer: "number" }[this.type] || this.type;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        if (String(value).length) {
          if (this.originType == "number") {
            const min = Number(isNull(this.min) ? -Infinity : this.min),
              max = Number(isNull(this.max) ? Infinity : this.max);
            value = Number(value);
            if (this.type == "integer") {
              value = parseInt(value);
            }
            if (value < min) {
              value = Math.max(value, min);
            }
            if (value > max) {
              value = Math.min(value, max);
            }
          }
        }
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.$el.ons(
      Object.entries(this.$listeners)
        .filter(([k]) => !["input"].includes(k))
        .reduce((p, [k, v]) => ((p[k] = v), p), {})
    );
    this.$el.on("blur", e => (this.$el.value = this.model));
  }
};
</script>

<style lang="less">
.v-input {
  width: 180px;
  outline: none;
  font-size: 14px;
  padding: 0px 6px;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  transition: 200ms;

  &:not(:disabled) {
    &:focus {
      border-color: #41b883;
    }
  }

  &[type="password"] {
    letter-spacing: 3px;

    &::placeholder {
      letter-spacing: initial;
    }
  }

  &[type="number"] {
    padding-right: 0px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      cursor: pointer;
      // -webkit-appearance: none;
    }
  }

  &[size="small"] {
    line-height: 20px;
  }
}
</style>
